import React, {
  useState,
  useContext,
  useEffect,
  Fragment,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { addPolicy, editPolicy } from "../../Policies/helper";
import RichTextBoxEditer from "../../../components/RichTextBoxEditer";
import DialogBoxComponent from "../../../components/DialogBoxComponent";
import PolicyContext from "../../../context/policy/PolicyContext";
import { useLocation } from "react-router-dom";
import { CardActions, IconButton, Stack, Typography } from "@mui/material";
import { ConfigProto } from "jodit/esm/core/helpers";
import { Container } from "@mui/material";
import { Card } from "@mui/material";
import { CardContent, CardHeader } from "@mui/material";
import { Tabs, Tab } from "@mui/material";
import RichTextBoxTabPanel from "../../../components/RichTextBoxEditerTabs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Tooltip } from "@mui/material";
import { useUserContext } from "../../../context/auth/UserContext";
import { useRiskManagementContext } from "../../../context/RiskManagement/RiskManagementContext";
import { createAppendix, updateAppendix } from "./helper";
import { convertToUTC, isClientAdmin } from "../../../utils/ConvertDate";
import { useAccessRights } from "../../../utils/useAccessRights";

const getFieldControlStyles = () => ({
  backgroundColor: "#F1F5F7",
  ".MuiOutlinedInput-root": {
    border: "none",
    "& fieldset": {
      border: "none",
    },
  },
  borderRadius: "8px",
});

export const ApendixForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const riskManagementPageAccess = useAccessRights("Risk Management - CS & SC");

  const [appendixName, setAppendixName] = useState<string>("");
  const [appendixContent, setAppendixContent] = useState<string>("");
  const [appendixStatus, setAppendixStatus] = useState<string>("");
  const [appendixApprovalDate, setAppendixApprovalDate] =
    useState<Dayjs | null>(null);
  const [formHeader, setFormHeader] = useState<string>("Create Appendix");
  const [isUpdated, setIsUpdated] = useState(false);
  const isUpdatedRef = useRef(isUpdated);
  const [isUserStillOnPage, setIsUserStillOnPage] = useState(false);
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openSuccessDialogBox: false,
  });

  const { userId, companyProfileID, userAccess } = useUserContext();
  const {
    tabValue,
    selectedRiskManagement,
    selectedAppendix,
    appendixDetails,
    setAppendixDetails,
    setSelectedAppendix,
  } = useRiskManagementContext();

  const handleCloseForm = () => {
    navigate("/risk-management-appendix");
    setFormHeader("");
    setAppendixDetails({});
    setSelectedAppendix({});
  };

  const handleCloseDialog = () => {
    setDialogState({
      ...dialogState,
      openSuccessDialogBox: false,
    });
    handleCloseForm();
  };

  const disableForm = () => {
    if (
      appendixName !== "" &&
      appendixDetails !== "" &&
      appendixStatus !== ""
    ) {
      if (appendixStatus === "Approved" && appendixApprovalDate === null) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  };

  const handleAddAppendix = async () => {
    const date = new Date();
    // const approvalDate = appendixApprovalDate && appendixApprovalDate.toDate();
    const payload = {
      content: appendixContent,
      title: appendixName,
      version: "1.1",
      status: appendixStatus,
      approvedDate: convertToUTC(appendixApprovalDate),
      approvedBy: appendixStatus === "Approved" ? userId : 0,
      createDate: date,
      createdBy: userId,
      companyProfileID: companyProfileID,
      ...(tabValue === 0
        ? {
            csRiskManagementPlanID:
              selectedRiskManagement?.csRiskManagementPlanID,
          }
        : {
            supplyChainPlanID: selectedRiskManagement?.supplyChainPlanID,
          }),
      isEditedByUserId: "0",
    };

    const res = await createAppendix(tabValue === 0, payload);
    if (res.succeeded === true) {
      setDialogState({
        title: "Success",
        body: "Appendix successfully created",
        action: "OK",
        actionCancel: "",
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openSuccessDialogBox: true,
      });
    }
  };

  const handleEditAppendix = async () => {
    setIsUpdated(true);
    const date = new Date();
    // const approvalDate = appendixApprovalDate
    //   ? dayjs.isDayjs(appendixApprovalDate)
    //     ? appendixApprovalDate
    //     : dayjs(appendixApprovalDate).isValid()
    //       ? dayjs(appendixApprovalDate).toDate()
    //       : null
    //   : null;
    const payload = {
      content: appendixContent,
      title: appendixName,
      version: "1.1",
      status: appendixStatus,
      approvedDate: convertToUTC(appendixApprovalDate),
      companyProfileID: companyProfileID,
      approvedBy:
        appendixStatus !== appendixDetails.status &&
        appendixStatus === "Approved"
          ? userId
          : 0,
      updateDate: date,
      updateBy: userId,
      ...(tabValue === 0
        ? {
            csRiskManagementPlanID:
              selectedRiskManagement?.csRiskManagementPlanID,
            csRiskManagementPlanAppendixID:
              selectedAppendix.csRiskManagementPlanAppendixID,
          }
        : {
            supplyChainPlanID: selectedRiskManagement?.supplyChainPlanID,
            scRiskManagementPlanAppendixID:
              selectedAppendix.scRiskManagementPlanAppendixID,
          }),
      isEditedByUserId: "0",
    };

    const res = await updateAppendix(tabValue === 0, payload);
    if (res.succeeded === true) {
      setDialogState({
        title: "Success",
        body: "Appendix successfully updated",
        action: "OK",
        actionCancel: "",
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openSuccessDialogBox: true,
      });
    }
  };

  useEffect(() => {
    if (appendixStatus !== "Approved") {
      setAppendixApprovalDate(null);
    }
  }, [appendixStatus]);

  useEffect(() => {
    if (
      appendixDetails?.csRiskManagementPlanAppendixID ||
      appendixDetails?.scRiskManagementPlanAppendixID
    ) {
      setFormHeader("Edit Appendix");
      const approvalDate = appendixDetails?.approvedDate
        ? dayjs(appendixDetails.approvedDate)
        : null;
      setAppendixName(appendixDetails.title);
      setAppendixContent(appendixDetails.content);
      setAppendixStatus(appendixDetails.status);
      setAppendixApprovalDate(approvalDate);
    } else {
      setFormHeader("Create Appendix");
      setAppendixStatus("Not Approved");
    }
  }, [appendixDetails]);

  useEffect(() => {
    console.log("isUpdated", isUpdated);
    isUpdatedRef.current = isUpdated;
  }, [isUpdated]);

  const handleExit = async (isEdited: boolean) => {
    console.log("handleExit", isUpdatedRef.current);
    if (
      (appendixDetails?.csRiskManagementPlanAppendixID ||
        appendixDetails?.scRiskManagementPlanAppendixID) &&
      !isUpdatedRef.current
    ) {
      const date = new Date();
      const payload = {
        ...appendixDetails,
        isEditedByUser: isEdited,
        isEditedByUserId: userId + "",
        updateBy: userId,
        updateDate: date,
      };
      try {
        const resUpdate = await updateAppendix(tabValue === 0, payload);
        console.log("handleExit resUpdate", resUpdate);
        if (resUpdate) {
          setIsUserStillOnPage(false);
          return resUpdate;
        }
      } catch (error) {
        console.log("@@Error", error);
      }
    }
  };

  useEffect(() => {
    return () => {
      handleExit(false);
    };
  }, [location]);

  useEffect(() => {
    console.log("isUserStillOnPage >> ", isUserStillOnPage);
    if (isUserStillOnPage) {
      handleExit(true);
    }
  }, [isUserStillOnPage]);

  useEffect(() => {
    console.log("beforeunload");

    const handleBeforeUnload = async (event: BeforeUnloadEvent) => {
      console.log("handleBeforeUnload", event);
      event.preventDefault();
      await handleExit(false);
      setIsUserStillOnPage(true);
      const message =
        "You have unsaved changes. Are you sure you want to leave? ";
      event.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <Fragment>
      <Container sx={{ p: 1, height: "100%", width: "100%" }}>
        <Card
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: "10px",
            overflow: "hidden",
          }}
        >
          <CardContent>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={() => handleCloseForm()}>
                <ArrowBackIcon />
              </IconButton>
              <Typography>{formHeader}</Typography>
            </div>
            <Container sx={{ p: 2 }}>
              <Stack
                direction="column"
                spacing={3}
                justifyContent="center"
                alignItems="center"
              >
                <Grid xs={12} width="80%">
                  <h4
                    style={{
                      color: "lightgrey",
                      fontWeight: "400",
                      fontStyle: "italic",
                      margin: "0.5rem 0",
                    }}
                  >
                    Appendix Name
                  </h4>
                  <TextField
                    fullWidth
                    variant="filled"
                    size="small"
                    value={appendixName}
                    onChange={(e) => setAppendixName(e.target.value)}
                  />
                </Grid>
                <Grid container justifyContent="center" width="80%">
                  <RichTextBoxEditer
                    readOnly={false}
                    editorContent={appendixContent}
                    onChange={(val) => setAppendixContent(val)}
                  />
                </Grid>
                <Grid container columnSpacing={1.5} width="80%">
                  <Grid xs={6}>
                    <Typography>Status</Typography>
                    <FormControl
                      size="small"
                      sx={getFieldControlStyles}
                      fullWidth
                      variant="outlined"
                    >
                      <Select
                        value={appendixStatus}
                        onChange={(e) => setAppendixStatus(e.target.value)}
                      >
                        <MenuItem value="Not Approved">Not Approved</MenuItem>
                        <MenuItem value="Ready to Approve">
                          Ready to Approve
                        </MenuItem>
                        <MenuItem
                          value="Approved"
                          disabled={!riskManagementPageAccess?.isApproved}
                        >
                          Approved
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid xs={6}>
                    <Typography>Approval Date</Typography>
                    <DatePicker
                      value={appendixApprovalDate}
                      onChange={(val) => setAppendixApprovalDate(val)}
                      slotProps={{ field: { clearable: true } }}
                    />
                  </Grid>
                </Grid>
              </Stack>
            </Container>
          </CardContent>
          <CardActions sx={{ justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0066FF1A",
                color: "#0066FF",
                "&:hover": {
                  bgcolor: "#0066FF1A",
                  "& .MuiTypography-root": {
                    color: "white",
                  },
                },
                boxShadow: 0,
                textTransform: "none",
              }}
              onClick={handleCloseForm}
            >
              Cancel
            </Button>
            {appendixDetails?.csRiskManagementPlanAppendixID ||
            appendixDetails?.scRiskManagementPlanAppendixID ? (
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  boxShadow: 0,
                  backgroundColor: "#0066FF",
                }}
                disabled={disableForm() || !riskManagementPageAccess?.isUpdate}
                onClick={handleEditAppendix}
              >
                Edit
              </Button>
            ) : (
              <Button
                variant="contained"
                sx={{
                  textTransform: "none",
                  boxShadow: 0,
                  backgroundColor: "#0066FF",
                }}
                disabled={disableForm() || !riskManagementPageAccess?.isCreate}
                onClick={handleAddAppendix}
              >
                Create
              </Button>
            )}
          </CardActions>
        </Card>
      </Container>
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
